<template>
    <div>
        <EnvProvider>
            <DeviceLayoutProvider :mobileThreshold="768">
                <GsapProvider>
                    <TimerProvider>
                        <MediaMetaProvider :data="mediaMetaData">
                            <FontLoaderProvider>
                                <ColorPaletteProvider>
                                    <slot />
                                </ColorPaletteProvider>
                            </FontLoaderProvider>
                        </MediaMetaProvider>
                    </TimerProvider>
                </GsapProvider>
            </DeviceLayoutProvider>
        </EnvProvider>
        <VersionPanel v-model="showVersionPanel" />
    </div>
</template>

<script setup>
    import { useNuxtApp } from '#app';
    import { DeviceLayoutProvider, MediaMetaProvider } from '@resn/gozer-vue';
    import { onMounted, ref } from 'vue';

    import VersionPanel from '~/components/debug/VersionPanel.vue';
    import mediaMetaData from '~/media-metadata.json';
    import ColorPaletteProvider from '~/providers/ColorPaletteProvider';
    import EnvProvider from '~/providers/EnvProvider';
    import FontLoaderProvider from '~/providers/FontLoaderProvider';
    import GsapProvider from '~/providers/gsap/GsapProvider.vue';
    import { TimerProvider } from '~/providers/TimerProvider';

    const showVersionPanel = ref(false);

    onMounted(() => {
        const { $registerVersionPanel } = useNuxtApp();
        if ($registerVersionPanel) {
            $registerVersionPanel({
                toggle: () => {
                    showVersionPanel.value = !showVersionPanel.value;
                },
                show: () => {
                    showVersionPanel.value = true;
                },
                hide: () => {
                    showVersionPanel.value = false;
                },
            });
        }
    });
</script>
